/**
 * Temporary work-around to handle the css rules that were added using the generated ID
 *
 * basically, this code just gets the section id and reformats it to remove the theme id,
 * and re-adds that as a class. The class corresponds to the classes in unstable-css.css
 *
 * @example
 *
 * #DP--template--16404600127536__design_pack_columns_simple_DKKr8d becomes .unstable--design_pack_columns_simple_DKKr8d
 */
(() => {
  const sections = document.querySelectorAll('section');
  sections.forEach((section) => {
    const id = section.id;
    let idWithoutTemplateId = '';

    if (!!id) {
      idWithoutTemplateId = `unstable--${id.split('__')[1]}`;

      section.classList.add(idWithoutTemplateId);
    }
  });
})();
